import TomSelect from 'tom-select';

const DeviceCompare = (() => {
    let devices = [],
        deviceImageMap = {},
        tomSelectInstances = {},
        currentFilteredDevices = [],
        compareFieldsWrapper,
        deviceSlugMap = {},
        initialLoad = true;

    const isMobile = () => window.innerWidth <= 768;
    const maxDevices = isMobile() ? 2 : 4;

    const setupTomSelect = (id, options = {}) => {
        const el = document.getElementById(id);
        if (!el) {
            return;
        }
        tomSelectInstances[id] = new TomSelect(`#${id}`, {
            placeholder: 'Vybrať zariadenie',
            allowEmptyOption: true,
            plugins: ['clear_button'],
            render: {
                option: (data, escape) => `<div><span>${escape(data.text)}</span></div>`,
                item: (data, escape) => `<div><span>${escape(data.text)}</span></div>`
            },
            ...options
        });
    };

    const getSelectedDeviceIds = (currentIdx) =>
        Array.from({ length: isMobile() ? 2 : 4 }, (_, i) => i + 1)
            .filter(i => i !== currentIdx)
            .map(i => tomSelectInstances[`device-select-${i}`]?.getValue())
            .filter(Boolean);

    const populateSelectWithDevices = (id, arr, exclude = [], keep = true) => {
        const select = tomSelectInstances[id];
        if (!select) return;
        const selected = keep ? select.getValue() : '';
        select.clearOptions();
        select.addOption({ value: '', text: 'Vybrať zariadenie' });
        arr.forEach(d => {
            if (!exclude.includes(d.slug) || d.slug === selected) {
                select.addOption({ value: d.slug, text: d.title });
            }
        });
        select.refreshOptions(false);
        if (keep && selected) {
            select.setValue(selected, true);
        } else {
            select.clear();
        }
    };

    const fetchDeviceSpecs = (slug, divId) => {
        const el = document.getElementById(divId);
        if (!el) return;
        if (!slug) {
            el.innerHTML = '';
            return;
        }
        const device = deviceSlugMap[slug];
        if (!device) return;
        fetch(window.ajaxUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `action=get_device_specs&device_id=${device.id}`
        })
            .then(r => r.json())
            .then(data => {
                el.innerHTML = data.success
                    ? data.data
                    : `Nepodarilo sa načítať špecifikácie.<br><small>${data.data || ''}</small>`;
                if (data.success) matchSpecGroupHeightsByTitle();
            });
    };

    const updateDeviceImage = (slug, imgId) => {
        const img = document.getElementById(imgId);
        if (!img) return;
        const wrapperId = `${imgId}-wrapper`;
        let wrapper = document.getElementById(wrapperId);

        if (!wrapper) {
            wrapper = document.createElement('a');
            wrapper.id = wrapperId;
            img.parentNode.insertBefore(wrapper, img);
            wrapper.appendChild(img);
        }

        if (slug && deviceImageMap[slug] && deviceSlugMap[slug]) {
            img.src = deviceImageMap[slug];
            img.style.display = '';
            wrapper.href = '/zariadenia/' + slug || '#';
            wrapper.style.display = '';
            wrapper.setAttribute('target', '_blank');
        } else {
            img.src = '';
            img.style.display = 'none';
            wrapper.href = '#';
            wrapper.style.display = 'none';
        }
    };

    const updateAllDeviceSelectOptions = () => {
        if (!currentFilteredDevices.length) return;
        for (let i = 1; i <= maxDevices; i++) {
            populateSelectWithDevices(
                `device-select-${i}`,
                currentFilteredDevices,
                getSelectedDeviceIds(i)
            );
        }
    };

    const matchSpecGroupHeightsByTitle = () => {
        const blocks = document.querySelectorAll('.single-device__spec.basic-info');
        const groups = {};
        blocks.forEach(block => {
            const title = block.querySelector('.single-device__spec-title')?.textContent.trim();
            if (!title) return;
            block.style.height = 'auto';
            (groups[title] = groups[title] || []).push(block);
        });
        Object.values(groups).forEach(group => {
            const max = Math.max(...group.map(b => b.offsetHeight));
            group.forEach(b => {
                b.style.height = max + 'px';
            });
        });
    };

    const handleDeviceTypeChange = (type) => {
        if (!compareFieldsWrapper) return;

        if (!type) {
            compareFieldsWrapper.style.display = 'none';
            for (let i = 1; i <= maxDevices; i++) {
                populateSelectWithDevices(`device-select-${i}`, []);
                updateDeviceImage('', `device-img-${i}`);
                document.getElementById(`device-specs-${i}`).innerHTML = '';
                tomSelectInstances[`device-select-${i}`].clear();
            }
            currentFilteredDevices = [];
            updateUrlFromSelections();

            localStorage.removeItem('compareType');
            localStorage.removeItem('compareDevices');
            return;
        }

        compareFieldsWrapper.style.display = '';
        currentFilteredDevices = devices.filter(d =>
            Array.isArray(d.type_slug) && d.type_slug.includes(type)
        );
        for (let i = 1; i <= maxDevices; i++) {
            populateSelectWithDevices(
                `device-select-${i}`,
                currentFilteredDevices,
                [],
                false
            );
            updateDeviceImage('', `device-img-${i}`);
            document.getElementById(`device-specs-${i}`).innerHTML = '';
        }

        if (!initialLoad) {
            window.history.replaceState({}, '', `/porovnanie/${type}/`);
        }

        localStorage.setItem('compareType', type);
        localStorage.setItem('compareDevices', JSON.stringify([]));
    };

    const handleDeviceSelectChange = (idx, slug) => {
        updateDeviceImage(slug, `device-img-${idx}`);
        fetchDeviceSpecs(slug, `device-specs-${idx}`);
        updateAllDeviceSelectOptions();
        updateUrlFromSelections();

        const type = tomSelectInstances['device-type-select'].getValue();
        const deviceSlugs = Array.from({ length: 4 }, (_, i) =>
            tomSelectInstances[`device-select-${i + 1}`]?.getValue()
        ).filter(Boolean);
        if (type) {
            localStorage.setItem('compareType', type);
            localStorage.setItem('compareDevices', JSON.stringify(deviceSlugs));
        }
    };

    const updateUrlFromSelections = () => {
        if (initialLoad) return;
        const type = tomSelectInstances['device-type-select'].getValue();
        const deviceSlugs = Array.from({ length: 4 }, (_, i) =>
            tomSelectInstances[`device-select-${i + 1}`]?.getValue()
        ).filter(Boolean);
        if (!type || !deviceSlugs.length) return;
        window.history.replaceState({}, '', `/porovnanie/${type}/${deviceSlugs.join('-vs-')}`);
    };

    const parsePrettyUrl = () => {
        const parts = window.location.pathname.split('/').filter(Boolean);
        return {
            type: parts[0] === 'porovnanie' ? parts[1] || null : null,
            devices: parts.length >= 3 ? parts[2].split('-vs-').filter(Boolean) : []
        };
    };

    const loadSelectionsFromUrl = () => {
        const { type: urlType, devices: urlDevices } = parsePrettyUrl();

        let selectedType = urlType || localStorage.getItem('compareType');
        let deviceSlugsToLoad = [];

        if (urlDevices && urlDevices.length) {
            deviceSlugsToLoad = urlDevices.slice(0, 4);
        } else {
            try {
                const arr = JSON.parse(localStorage.getItem('compareDevices') || '[]');
                if (Array.isArray(arr)) deviceSlugsToLoad = arr.slice(0, 4);
            } catch (e) {
                deviceSlugsToLoad = [];
            }
        }

        if (!selectedType) {
            initialLoad = false;
            return;
        }

        if (tomSelectInstances['device-type-select']) {
            tomSelectInstances['device-type-select'].setValue(selectedType, true);
        }
        handleDeviceTypeChange(selectedType);

        setTimeout(() => {
            deviceSlugsToLoad.forEach((slug, i) => {
                if (tomSelectInstances[`device-select-${i + 1}`]) {
                    const selectInstance = tomSelectInstances[`device-select-${i + 1}`];
                    if (slug && selectInstance) {
                        const exists = currentFilteredDevices.some(d => d.slug === slug);
                        if (exists) {
                            selectInstance.setValue(slug, true);
                            handleDeviceSelectChange(i + 1, slug);
                        }
                    }
                }
            });

            setTimeout(() => { initialLoad = false; }, 300);
        }, 300);
    };

    const init = () => {
        devices = window.DeviceCompare || [];
        deviceImageMap = {};
        deviceSlugMap = {};
        devices.forEach(d => {
            deviceSlugMap[d.slug] = d;
            deviceImageMap[d.slug] = d.image;
        });
        tomSelectInstances = {};
        compareFieldsWrapper = document.getElementById('compare-fields-wrapper');
        if (compareFieldsWrapper) compareFieldsWrapper.style.display = 'none';

        setupTomSelect('device-type-select', {
            placeholder: 'Vybrať typ zariadenia',
            render: {
                option: (data, escape) => `<div><span>${escape(data.text)}</span></div>`,
                item: (data, escape) => `<div><span>${escape(data.text)}</span></div>`
            }
        });

        for (let i = 1; i <= maxDevices; i++) {
            setupTomSelect(`device-select-${i}`, {
                onChange: val => handleDeviceSelectChange(i, val)
            });
            populateSelectWithDevices(`device-select-${i}`, []);
            updateDeviceImage('', `device-img-${i}`);
        }

        window.addEventListener('resize', matchSpecGroupHeightsByTitle);

        loadSelectionsFromUrl();

        if (tomSelectInstances['device-type-select']) {
            tomSelectInstances['device-type-select'].on('change', handleDeviceTypeChange);
        }

        document.addEventListener('click', function (e) {
            const btn = e.target.closest('.add-to-compare');
            if (!btn) return;

            const slug = btn.getAttribute('data-device');
            const type = btn.getAttribute('data-device-type');

            if (!slug) return;

            const storedType = localStorage.getItem('compareType');

            if (storedType && type && storedType !== type) {
                const confirmReset = confirm(
                    'Máte vybrané zariadenia iného typu. Chcete ich nahradiť novým výberom?'
                );
                if (!confirmReset) return;

                localStorage.removeItem('compareDevices');
            }

            if (type) {
                localStorage.setItem('compareType', type);
            } else if (!storedType) {
                alert('Prosím vyberte typ zariadenia na stránke porovnania pred pridaním.');
                window.location.href = '/porovnanie/';
                return;
            }

            const currentType = type || storedType;

            let arr = [];
            const storedJson = localStorage.getItem('compareDevices');
            if (storedJson) {
                try {
                    arr = JSON.parse(storedJson);
                    if (!Array.isArray(arr)) arr = [];
                } catch (e) {
                    arr = [];
                }
            }

            if (!arr.includes(slug)) {
                if (arr.length < (isMobile() ? 2 : 4)) {
                    arr.push(slug);
                } else {
                    alert(`V porovnávači máte už maximálny počet zariadení (${isMobile() ? 2 : 4}).`);
                    window.location.href = `/porovnanie/`;
                    return;
                }
            }

            localStorage.setItem('compareDevices', JSON.stringify(arr));

            window.location.href = `/porovnanie/${currentType}/`;
        });
    };

    return { init };
})();

export default DeviceCompare;

document.addEventListener("DOMContentLoaded", () => {
  DeviceCompare.init();
});